import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const kolomData = [
  'NoNota',
  'KodeReferensi',
];

const NotaFilter = ({ data = [], onClose }) => {
  const navigate = useNavigate();

  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [lokasi, setLokasi] = useState('');
  const [selectedColumns, setSelectedColumns] = useState([]);

  const handleCheckboxChange = (column) => {
    setSelectedColumns((prev) =>
      prev.includes(column)
        ? prev.filter((c) => c !== column)
        : [...prev, column]
    );
  };

  const handlePrint = () => {
    if (selectedColumns.length === 0) {
      alert('Pilih minimal satu kolom untuk dicetak.');
      return;
    }

    const filteredData = data.filter((item) => {
      if (fromDate && new Date(item.TanggalNota) < new Date(fromDate)) return false;
      if (toDate && new Date(item.TanggalNota) > new Date(toDate)) return false;
      return true; // lokasi tidak digunakan untuk filter
    });

    const printableData = filteredData.map((item) => {
      const obj = {
        NoNota: item.NoNota ?? '-',
        KodeReferensi: item.KodeReferensi ?? '-',
      };
      selectedColumns.forEach((col) => {
        if (!['NoNota', 'KodeReferensi'].includes(col)) {
          obj[col] = item[col] ?? '-';
        }
      });
      return obj;
    });

    if (printableData.length === 0) {
      alert('Tidak ada data yang sesuai dengan filter.');
      return;
    }

    navigate('/nota-preview', {
      state: {
        filteredData: printableData,
        selectedColumns,
        fromDate,
        toDate,
        lokasi, // tetap dikirim ke preview untuk ditampilkan
      },
    });
  };

  return (
 <div
  className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
  onClick={onClose}
>
  <div
    className="bg-white rounded-xl shadow-lg p-4 sm:p-5 w-full max-w-[720px] max-h-[85vh] overflow-y-auto"
    onClick={(e) => e.stopPropagation()}
  >
    <h3 className="mb-4 text-lg font-semibold text-gray-800">Filter Serah Terima Nota</h3>

    {/* Form Filter */}
    <div className="grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
      <div>
        <label className="block mb-1 text-sm font-medium text-gray-700">Dari Tanggal Nota</label>
        <input
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
        />
      </div>
      <div>
        <label className="block mb-1 text-sm font-medium text-gray-700">Sampai Tanggal Nota</label>
        <input
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
        />
      </div>
      <div className="sm:col-span-2">
        <label className="block mb-1 text-sm font-medium text-gray-700">Lokasi</label>
        <input
          type="text"
          placeholder="Masukkan lokasi (untuk ditampilkan)"
          value={lokasi}
          onChange={(e) => setLokasi(e.target.value)}
          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500"
        />
      </div>
    </div>

    {/* Checklist Kolom */}
    <div className="mb-4">
      <label className="block mb-2 text-sm font-medium text-gray-700">Kolom yang ingin dicetak</label>
      <div className="grid grid-cols-2 gap-2 p-3 overflow-y-auto text-sm border border-gray-200 rounded sm:grid-cols-3 max-h-48 bg-gray-50">
        {kolomData.map((col) => (
          <label key={col} className="flex items-center gap-2 text-gray-800">
            <input
              type="checkbox"
              checked={selectedColumns.includes(col)}
              onChange={() => handleCheckboxChange(col)}
              className="accent-green-600"
            />
            <span>{col}</span>
          </label>
        ))}
      </div>
    </div>

    {/* Tombol Aksi */}
    <div className="flex justify-end gap-3 mt-5">
      <button
        onClick={handlePrint}
        className="px-4 py-2 text-sm text-white transition bg-green-600 rounded-md shadow-sm hover:bg-green-700"
      >
        Preview
      </button>
      <button
        onClick={onClose}
        className="px-4 py-2 text-sm text-white transition bg-gray-400 rounded-md shadow-sm hover:bg-gray-500"
      >
        Batal
      </button>
    </div>
  </div>
</div>



  );
};

export default NotaFilter;
